import React, { useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export default function ForgotPassword() {
   
   const emailRef = useRef()
   const { resetPassword} = useAuth()
   const [error, setError] = useState('')
   const [message, setMessage] = useState('')
   const [loading, setLoading] = useState(false)

   async function handleSubmit(e) {
      e.preventDefault()

      try {
        setMessage('')
         setError('')
         setLoading(true)
         await resetPassword(emailRef.current.value)
         setMessage('Check your inbox for futher instructions')
      }
      catch {
         setError('Failed to reset password')
      }
      setLoading(false)
   }

   return (
      <div class="bg-grey-lighter min-h-screen flex flex-col">
            <div class="container max-w-sm mx-auto flex-1 flex flex-col items-center justify-center px-2">
                <div class="bg-white px-6 py-8 rounded shadow-md text-black w-full">
                    <h1 class="mb-8 text-3xl text-center">Password Reset</h1>
                    {error && <alert className = "bg-red-200 text-center text-xl ">{error}</alert> }
                    {message && <alert className = "bg-red-100 text-center text-xl ">{message}</alert>}
                    <form onSubmit={handleSubmit}>
                    <input 
                        type="text"
                        class="block border border-grey-light w-full p-3 rounded mb-4"
                        name="fullname"
                        placeholder="Full Name" />

                    <input 
                        type="text"
                        class="block border border-grey-light w-full p-3 rounded mb-4"
                        name="email"
                        placeholder="Email" 
                        ref={emailRef}
                        />

                    <button disabled={loading}
                        type="submit"
                        class="w-full text-center py-3 rounded bg-green-50 text-black hover:bg-green-100 focus:outline-none my-1"
                    >Reset Password</button>

                    <div className="text-center text-blue-500 my-3">
                        <Link to="/login">Log In</Link>
                    </div>

                    </form>
                    <div class="text-center text-sm text-grey-dark mt-4">
                        By Logging in, you agree to the 
                        <a class="no-underline border-b border-grey-dark text-grey-dark" href="#">
                            Terms of Service
                        </a> and 
                        <a class="no-underline border-b border-grey-dark text-grey-dark" href="#">
                            Privacy Policy
                        </a>
                    </div>
                </div>

                <div class="text-grey-dark mt-6">
                    Need an account? 
                    <a class="no-underline border-b border-blue text-blue" href="#">
                        <Link to="/signup">Sign Up</Link>
                    </a> 
                </div>
            </div>
        </div>
   )
}
